<template>
  <div class="invoice-container">
    <PageHeader title="ثبت قبض" :infoLearnUrl="infoLearnUrl" infoTitle="راهنمای ثبت قبض">
      <template #info>
        <p style="line-height:1.9; white-space:pre-line;">
          جهت ثبت قبض ابتدا دکمه قبض جدید را زده سپس نام بیمار را انتخاب کنید سپس خدمات و کالاهای مصرفی مورد نظر را از قسمت
          اقلام فاکتور برای بیمار مد نظر انتخاب کنید. در صورت نیاز به اضافه کردن ردیف جدید بر روی دکمه افزودن ردیف جدید کلیک
          کنید. در نهایت برای ثبت قبض روی دکمه «ثبت قبض» کلیک نمایید.

          پس از پرداخت هزینه توسط بیمار، بر روی دکمه «تسویه» کلیک کرده و هزینه پرداختی بیمار را ثبت کنید. برای تنظیمات چاپ
          قبض و چاپ قبض دلخواه به تنظیمات مطب مراجعه نمایید.

          جهت مشاهده فیلم و راهنمای کامل آموزشی بر روی لینک زیر کلیک نمایید.
        </p>
      </template>
    </PageHeader>
    <!-- ردیف بالا با فیلدهای مورد نظر -->
    <div class="invoice-header">
      <div class="header-row">
        <div class="navigation-buttons">
          <button @click="nextInvoice" class="nav-btn nav-btn-right"
            :disabled="currentInvoiceIndex >= totalInvoices - 1" title="فاکتور قبلی">
            <ArrowRightSvg />
          </button>
          <span class="invoice-counter">
            {{ currentInvoiceIndex + 1 }} از {{ totalInvoices }}
          </span>
          <button @click="previousInvoice" class="nav-btn nav-btn-left" :disabled="currentInvoiceIndex <= 0"
            title="فاکتور بعدی">
            <ArrowLeft />
          </button>
        </div>
        <!-- تاریخ -->
        <div class="form-group date-group">
          <label for="invoice-date">تاریخ:<span class="required">*</span></label>
          <div class="p-date" style="width: 100% !important">
            <DatePicker v-model="invoiceData.fMdate" format="jYYYY/jMM/jDD" display-format="jYYYY/jMM/jDD"
              :editable="true" :clearable="false" :auto-submit="true" :show-now-btn="false" placeholder="انتخاب تاریخ"
              class="form-date-picker" input-class="form-input" />
          </div>
        </div>
        <!-- شماره قبض -->
        <div class="form-group invoice-group">
          <label for="invoice-number">شماره قبض:<span class="required">*</span></label>
          <input id="invoice-number" type="text" v-model="invoiceData.fMfactno" class="form-input"
            placeholder="شماره قبض" @keyup.enter.prevent="onReceptionChange" />
        </div>
        <!-- شماره پذیرش removed per UX request: field intentionally omitted from UI -->
        <!-- نام پزشک -->
        <div class="form-group doctor-group">
          <GenericSelect key="doctor-select" label="نام و نام خانوادگی پزشک" required="true" v-model="invoiceData.fMdocid" entity-type="doctor"
            :store="doctorsComboStore" label-field="fDname" value-field="fDauto" secondary-field="fDnezamno"
            placeholder="جستجو بر اساس نام، تخصص، نظام پزشکی..." :enable-enter-search="true" :refetch-on-clear="true"
            :enable-infinite-scroll="false" :append-to-body="true" @item-selected="onDoctorSelected"
            @search="onDoctorSearch" @clear="onDoctorClear">
            <template #option="{ fDname, fDtakhasos, fDnezamno }">
              <div class="doctor-option">
                <div class="doctor-main">
                  <strong> {{ fDname }} </strong>
                </div>
                <div class="doctor-secondary">
                  <span v-if="fDtakhasos" class="specialty"> تخصص: {{ fDtakhasos }} </span>
                </div>
                <div class="doctor-secondary">
                  <span v-if="fDnezamno" class="medical-code">نظام پزشکی: {{ fDnezamno }}</span>
                </div>
              </div>
            </template>
          </GenericSelect>
        </div>
      </div>
    </div>

    <!-- ردیف دوم: نام بیمار و شماره پذیرش -->
    <div class="invoice-second-row">
      <div class="second-row-content">
        <!-- نام بیمار با جستجو -->
        <div class="form-group patient-search-group">
          <label for="patient-search">نام بیمار:<span class="required">*</span></label>

          <GenericSelect key="patient-select" v-model="invoiceData.fMprsnid" entity-type="patient"
            :store="patientsComboStore" label-field="fFami" value-field="fTauto" secondary-field="pmeli"
            placeholder="جستجو بر اساس نام، نام خانوادگی، کدملی..." :enable-enter-search="true" :refetch-on-clear="true"
            :enable-infinite-scroll="false" @item-selected="onPatientSelected" @search="onPatientSearch"
            @clear="onPatientClear">
            <template #option="{ fFami, fTname, pmeli }">
              <div class="patient-option">
                <div class="patient-main">
                  <strong>{{ fFami }} {{ fTname }}</strong>

                </div>
                <div class="patient-secondary">
                  <span class="file-number">پرونده: {{ fParno }}</span>
                </div>
                <div class="patient-secondary">
                  <span v-if="pmeli" class="national-code">کدملی: {{ pmeli }}</span>
                </div>
              </div>
            </template>
          </GenericSelect>
        </div>

        <!-- شماره نوبت -->

        <div class="form-group" v-if="selectedPatient">
          <label for="reception-number">شماره پرونده:</label>
          <input id="reception-number" type="text" :disabled="true" v-model="selectedPatient.fParno" class="form-input"
            placeholder="شماره پرونده" />
        </div>
        <!-- نوع بیمه -->
        <div class="form-group">
          <label>نوع بیمه <span class="required">*</span></label>
          <select v-model="invoiceData.fBimeh" required>
            <option value="">انتخاب کنید</option>
            <option value="1">آزاد</option>
            <option value="2">تامین اجتماعی</option>
            <option value="3">نیروهای مسلح</option>
          </select>
        </div>
        <!-- واسطه -->
        <div class="form-group intermediary-search-group">
          <label for="intermediary-search">واسطه:</label>
          <GenericSelect key="relation-select" v-model="invoiceData.fMvasete" entity-type="relation"
            :store="patientsComboStore" label-field="fFami" value-field="fTauto" secondary-field="pmeli"
            placeholder="جستجو بر اساس نام، نام خانوادگی، کدملی..." :enable-enter-search="true" :refetch-on-clear="true"
            :enable-infinite-scroll="false" @item-selected="onRelationSelected" @search="onRelationSearch">
            <template #option="{ fFami, fTname, pmeli }">
              <div class="patient-option">
                <div class="patient-main">
                  <strong>{{ fFami }} {{ fTname }}</strong>
                </div>
                <div class="relation-secondary">
                  <span v-if="pmeli" class="national-code">کدملی: {{ pmeli }}</span>
                </div>
              </div>
            </template>
          </GenericSelect>
        </div>
      </div>
    </div>

    <!-- محتوای اصلی فاکتور -->
    <div class="invoice-content">
      <div class="invoice-form">
        <h3>جزئیات فاکتور</h3>

        <!-- اطلاعات خلاصه -->
        <div class="summary-info">
          <div class="info-row">
            <div class="info-item">
              <strong>شماره قبض:</strong>
              {{ invoiceData.fMfactno || 'تعیین نشده' }}
            </div>
            <div class="info-item">
              <strong>تاریخ:</strong>
              {{ formattedDate }}
            </div>
            <!-- شماره پذیرش display removed per UX request -->
            <div v-if="selectedDoctor" class="info-item">
              <strong>پزشک:</strong>
              دکتر {{ selectedDoctor.firstName }} {{ selectedDoctor.lastName }}
            </div>
            <div v-if="selectedPatient" class="info-item">
              <strong>بیمار:</strong>
              {{ selectedPatient.fTname }} {{ selectedPatient.fFami }}
              <span class="patient-file-info">(پرونده: {{ selectedPatient.fParno }})</span>
            </div>
          </div>
        </div>

        <!-- جدول اقلام فاکتور -->
        <div class="invoice-items">
          <h4>اقلام فاکتور</h4>
          <div class="items-table">
            <BaseTable
              :items="invoiceData.items"
              :empty-colspan="9"
              key-field="fMrdf"
              :row-key="(row, idx) => row?.fMrdf ?? idx"
            >
              <template #head>
                <tr>
                  <th>شرح خدمات/کالا</th>
                  <th>تعداد</th>
                  <th>سهم بیمار</th>
                  <th>تخفیف</th>
                  <th>مبلغ پس از تخفیف</th>
                  <th>ارزش افزوده (%)</th>
                  <th>مالیات</th>
                  <th>جمع کل با مالیات</th>
                  <th>عملیات</th>
                </tr>
              </template>

              <template #row="{ item, index }">
                <td data-label="شرح خدمات/کالا">
                  <!-- Make service select compact so it doesn't force the table to wrap -->
                  <GenericSelect
                    class="compact-select"
                    :key="'service-select-' + index"
                    v-model="item.fMbsauto"
                    entity-type="service"
                    :store="serviceComboStore"
                    label-field="fSname"
                    value-field="fSauto"
                    secondary-field="fScode"
                    placeholder="جستجو بر اساس کد یا نام سرویس..."
                    :enable-enter-search="true"
                    :append-to-body="true"
                    :refetch-on-clear="true"
                    :enable-infinite-scroll="false"
                    @item-selected="(service) => onServiceSelected(index, service)"
                    @search="onServiceSearch"
                    @clear="onServiceClear"
                  >
                    <template #option="{ fSname, fScode }">
                      <div class="service-option">
                        <div class="doctor-main">
                          <strong> {{ fSname }} </strong>
                        </div>
                        <div class="service-secondary">
                          <span class="specialty"> کد: {{ fScode }}</span>
                        </div>
                      </div>
                    </template>
                  </GenericSelect>
                </td>

                <td data-label="تعداد">
                  <input
                    type="number"
                    v-model="item.fMtedad"
                    class="table-input"
                    min="1"
                    @input="calculateItemTotal(index)"
                  />
                </td>

                <td data-label="سهم بیمار">
                  <input
                    type="number"
                    v-model="item.fMpmblg"
                    class="table-input"
                    placeholder="قیمت"
                    @input="calculateItemTotal(index)"
                  />
                </td>

                <td data-label="تخفیف">
                  <input
                    type="number"
                    v-model="item.fMdtakhfif"
                    class="table-input"
                    placeholder="تخفیف"
                    min="0"
                    @input="calculateItemTotal(index)"
                  />
                </td>

                <td data-label="مبلغ پس از تخفیف">
                  {{ formatNumber(item.fMdkprice || 0) }}
                </td>

                <td data-label="ارزش افزوده (%)">%10</td>

                <td data-label="مالیات">
                  {{ formatNumber(item.fMdmalyat || 0) }}
                </td>

                <td data-label="جمع کل با مالیات">
                  {{ formatNumber(item.fMdmprice || 0) }} ریال
                </td>

                <td class="actions-cell" data-label="عملیات">
                  <button @click.stop="removeItem(index)" class="btn-remove" title="حذف ردیف">×</button>
                </td>
              </template>

              <template #empty>
                موردی برای نمایش وجود ندارد.
              </template>
            </BaseTable>
          </div>

          <div class="table-actions">
            <BaseButton title="افزودن ردیف جدید" variant="secondary" type="button" @click="addItem" />
          </div>

          <!-- جمع کل -->
          <div class="invoice-total">
            <div class="total-row">
              <span class="total-label">مبلغ بدون ارزش افزوده:</span>
              <span class="total-amount">{{ formatNumber(totalWithoutVat) }} ریال</span>
            </div>
            <div class="total-row">
              <span class="total-label">مجموع ارزش افزوده:</span>
              <span class="total-amount">{{ formatNumber(totalVatAmount) }} ریال</span>
            </div>
            <div class="total-row final-total">
              <span class="total-label">جمع کل نهایی:</span>
              <span class="total-amount">{{ formatNumber(totalAmount) }} ریال</span>
            </div>
          </div>
        </div>

        <!-- توضیحات (راست) + دکمه‌ها (چپ) -->
        <div class="form-actions-row">
          <div class="form-group notes-group">
              <label for="invoice-notes">توضیحات:</label>
              <textarea id="invoice-notes" v-model="invoiceData.fMdesc" class="form-input" placeholder="توضیحات قبض"
                rows="3"></textarea>
            </div>
          <div class="actions-column">
            <div class="actions-row">
              <BaseButton title="قبض جدید" variant="success" type="button" @click="newInvoice">
                <template #icon>
                  <span class="btn-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                      <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    </svg>
                  </span>
                </template>
              </BaseButton>
              <BaseButton title="حذف قبض" variant="danger" type="button" @click="deleteInvoice">
                <template #icon>
                  <span class="btn-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                      <path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14M10 10v8m4-8v8" stroke="currentColor" stroke-width="2"
                        stroke-linecap="round" />
                    </svg>
                  </span>
                </template>
              </BaseButton>
              <BaseButton title="ابطال قبض" variant="outline-danger" type="button" @click="voidInvoice">
                <template #icon>
                  <span class="btn-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                      <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    </svg>
                  </span>
                </template>
              </BaseButton>
            </div>
            <div class="actions-row">
              <span class="save-invoice-btn-wrap">
                <BaseButton title="ثبت قبض" variant="primary" type="button" @click="saveInvoice" :disabled="!canSaveInvoice">
                  <template #icon>
                    <span class="btn-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24">
                        <path d="M5 20h14a1 1 0 001-1V7l-4-4H6a1 1 0 00-1 1v16a1 1 0 001 1zm3-9h8m-8 4h5"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                      </svg>
                    </span>
                  </template>
                </BaseButton>

                <!-- When save is disabled, show an invisible overlay that can receive clicks/keyboard -->
                <span
                  v-if="!canSaveInvoice"
                  class="save-invoice-btn-overlay"
                  role="button"
                  aria-label="راهنمای تکمیل اطلاعات قبض"
                  tabindex="0"
                  @click="onDisabledSaveClick"
                  @keydown.enter.prevent="onDisabledSaveClick"
                  @keydown.space.prevent="onDisabledSaveClick"
                ></span>
              </span>
              <BaseButton title="چاپ قبض" variant="outline-success" type="button" @click="printInvoice">
                <template #icon>
                  <span class="btn-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                      <path d="M7 17h10v4H7v-4zm10-6h-1V5H8v6H7a3 3 0 00-3 3v3h4v-2h8v2h4v-3a3 3 0 00-3-3z"
                        fill="currentColor" />
                    </svg>
                  </span>
                </template>
              </BaseButton>
              <BaseButton title="تسویه" variant="secondary" type="button" @click="settleInvoice">
                <template #icon>
                  <span class="btn-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24">
                      <path
                        d="M20 7H4a2 2 0 00-2 2v6a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2zm-9 3h2a2 2 0 110 4h-2m0-4v4m9-5h.01M4 12h.01"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    </svg>
                  </span>
                </template>
              </BaseButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Info is handled by PageHeader -->
  <teleport to="body">
  <InfoModal
    v-model="openSaveHintModal"
    title="راهنمای تکمیل اطلاعات قبض"
    :closeOnOverlay="true"
    :showLearnLink="false"
    defaultContent="لطفا اطلاعات قبض شامل ( نام پزشک، نام بیمار، شرح خدمات و هزینه خدمات) را به صورت کامل وارد نمایید."
  />
  <div v-if="showSettleModal" data-testid="settle-modal" class="modal-overlay center-modal-overlay">
    <div class="modal-content">
      <div class="modal-sub-header">
        <div class="sub-header">
          <ModalHeader>
            <template #default>
              <h2 class="page-title">تسویه قبض</h2>
            </template>
          </ModalHeader>
          <div class="form-actions">
            <button type="button" class="new-button" @click="newSettlement">جدید</button>
            <BaseButton title="ثبت" variant="primary" type="button" @click="saveSettlement" />
            <BaseButton title="انصراف" variant="cancel" @click="closeSettleModal" />
          </div>
        </div>
        <hr class="divider-line" />
        <div class="settle-header-text" style="padding: 0 12px;">
          <p>
            تسویه قبض به شماره: <strong>{{ invoiceData.fMfactno || '-' }}</strong>
            تاریخ: <strong>{{ formattedDate }}</strong>
            مربوط به: <strong>{{ selectedPatient ? selectedPatient.fTname + ' ' + selectedPatient.fFami : '-' }}</strong>
            و پزشک: <strong>{{ selectedDoctor ? selectedDoctor.firstName + ' ' + selectedDoctor.lastName : '-' }}</strong>
          </p>
        </div>
      </div>
      <div class="modal-body">
  <div class="settle-form-grid" style="display:grid; grid-template-columns: 1fr 1fr 1fr; gap:12px;">
          <div class="form-group">
            <label>تاریخ دریافت</label>
            <div class="p-date">
              <DatePicker v-model="settleForm.date" format="jYYYY/jMM/jDD" display-format="jYYYY/jMM/jDD" :editable="true" :clearable="false" :auto-submit="true" :show-now-btn="false" class="form-date-picker" input-class="form-input" />
            </div>
          </div>
          <div class="form-group">
            <label>مبلغ دریافت</label>
            <input type="number" v-model.number="settleForm.amount" class="form-input" />
          </div>
          <div class="form-group">
            <label>نوع دریافت</label>
            <select v-model="settleForm.type" class="form-input">
              <option value="">انتخاب کنید</option>
              <option v-for="t in settleTypes" :key="t" :value="t">{{ t }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>شماره مدرک</label>
            <input type="text" v-model="settleForm.docNumber" class="form-input" />
          </div>
          <div class="form-group">
            <label>بابت</label>
            <input type="text" v-model="settleForm.reason" class="form-input" />
          </div>
          <div class="form-group">
            <label>توضیحات</label>
            <input type="text" v-model="settleForm.notes" class="form-input" placeholder="توضیحات" maxlength="250" />
          </div>
        </div>
        <hr class="divider-line" />
        <div class="settle-records-table" style="margin-top:12px;">
          <table class="patients-table">
            <thead>
              <tr>
                <th>ردیف</th>
                <th>تاریخ</th>
                <th>مبلغ</th>
                <th>نوع</th>
                <th>شماره مدرک</th>
                <th>بابت</th>
                <th>توضیحات</th>
                <th class="actions-header">عملیات</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!settleRecords || settleRecords.length === 0">
                <td :colspan="8" class="empty-row">هیچ رکوردی ثبت نشده است</td>
              </tr>
              <tr v-for="(rec, idx) in settleRecords" :key="rec.id">
                <td>{{ idx + 1 }}</td>
                <td>{{ rec.date }}</td>
                <td>{{ formatNumber(rec.amount) }} ریال</td>
                <td>{{ rec.type }}</td>
                <td>{{ rec.docNumber }}</td>
                <td>{{ rec.reason }}</td>
                <td>{{ rec.notes }}</td>
                <td class="actions-cell">
                  <button class="action-btn edit" @click="editSettlement(idx)"><img src="/img/edit.svg" alt="ویرایش" /></button>
                  <button class="action-btn delete" @click="deleteSettlement(idx)"><img src="/img/note.svg" alt="حذف" /></button>
                  <button class="action-btn print" @click="printSettlement(idx)"><img src="/img/print.svg" alt="پرینت" /></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </div>
  </teleport>
</template>

<script setup>
import { ref, computed, onMounted, watch, reactive } from 'vue'
import { useDoctorsStore } from '@/stores/clinic/doctors'
import { usePatientsStore } from '@/stores/clinic/patients'
import { useReceptionsStore } from '@/stores/clinic/receptions'
import DatePicker from 'vue3-persian-datetime-picker'
import { useConfirm } from '@/stores/composables.js'
import moment from 'jalali-moment'
import ArrowLeft from '@/components/svgs/ArrowLeft.vue'
import ArrowRightSvg from '@/components/svgs/ArrowRightSvg.vue'
import GenericSelect from '@/components/generic-select.vue'
import PageHeader from '@/components/PageHeader.vue'
import ModalHeader from '@/components/ModalHeader.vue'
import BaseButton from '@/components/UiCompunents/BaseButton.vue'
import BaseTable from '@/components/UiCompunents/BaseTable.vue'
import InfoModal from '@/components/InfoModal.vue'

import { usePatientsComboStore } from '@/stores/VueSelectStores/patientsCombo'
import { useServiceComboStore } from '@/stores/VueSelectStores/serviceCombo'
import { useDoctorsComboStore } from '@/stores/VueSelectStores/doctorsCombo';
import { useFactorsStore } from '@/stores/clinic/factor';
import { storeToRefs } from 'pinia'
import { useToast } from 'vue-toastification'

// --- STORE SETUP ---
const doctorsStore = useDoctorsStore()
const patientsStore = usePatientsStore()
const receptionsStore = useReceptionsStore()
const serviceComboStore = useServiceComboStore()
const patientsComboStore = usePatientsComboStore();
const doctorsComboStore = useDoctorsComboStore();
const factorsStore = useFactorsStore();
const { FactorEntity } = storeToRefs(factorsStore);
const { fetchFactor, addFactor, updateFactor, deleteFactor, CancelInvoice, deleteFactorItem, GetMaxFactorNumber } = factorsStore;
// Guard to avoid duplicate GetMaxFactorNumber calls for same doctor id
const lastFactorDoctorId = ref(null);
const selectedDoctor = ref(null);
const toast = useToast();

// Save hint modal (shown when user clicks disabled "ثبت قبض")
const openSaveHintModal = ref(false)

// Navigation state
const currentInvoiceIndex = ref(0)
const totalInvoices = ref(1)

// Patient search state
const patientSearchQuery = ref('')
const showPatientDropdown = ref(false)
const selectedPatient = ref(null)
const selectedRelation = ref(null)

// Intermediary search state
const intermediarySearchQuery = ref('')
const showIntermediaryDropdown = ref(false)
const selectedIntermediary = ref(null)


// Invoice data
const invoiceData = ref({
  fMfactid: 0,
  fMfactno: 0,
  fMbatel: 0,
  fMdate: moment().format('jYYYY/jMM/jDD'),
  fMmyno: '',
  fMdocid: null,
  fMprsnid: null,
  fBimeh: 1,
  fMvasete: null,
  fMdesc: '',
  items: [
    {
      description: '',
      fMbsauto: null,
      fMrdf: 0,
      fMtedad: 1,
      fMpmblg: 0,
      fMdtakhfif: 0,
      vatRate: 10,
      total: 0,
      vatAmount: 0,
      fMdmprice: 0,
      fMdkprice: 0,
      fMdmalyat: 0,
    }
  ]
})

// Info modal state & link
// Info modal link handled by PageHeader; no local state required
const infoLearnUrl = 'https://www.sinapardazesh.ir/matab-learning-web/'

// Settlements (تسویه) modal state
const showSettleModal = ref(false)
const settleForm = reactive({
  date: moment().format('jYYYY/jMM/jDD'),
  amount: 0,
  type: '',
  docNumber: '',
  reason: '',
  notes: ''
})
const settleRecords = ref([])
const editingSettleIndex = ref(-1)
const settleTypes = ref(['نقدی', 'کارت', 'انتقال بانکی', 'چک', 'سایر'])

// Computed properties
const receptionsList = computed(() => receptionsStore.receptionsList)
// --- patient ---
const onPatientSelected = (patient) => {
  if (patient) {
    invoiceData.value.fMprsnid = patient.fTauto;
    // Update the top-level selectedPatient that shows up in the invoice summary
    selectedPatient.value = patient;
  } else {
    invoiceData.value.fMprsnid = null;
    selectedPatient.value = ref(null);
  }
};

const onPatientSearch = (query) => {
};

const onPatientClear = () => {
  invoiceData.value.fMprsnid = null;
  selectedPatient.value = null;
};
// --- relation ---
const onRelationSelected = (relation) => {
  if (relation) {
    invoiceData.value.fMvasete = relation.fTauto;
    // Update the top-level selectedPatient that shows up in the invoice summary
    selectedRelation.value = relation;
  } else {
    invoiceData.value.fMvasete = null;
    selectedRelation.value = ref(null);
  }
};

const onRelationSearch = (query) => {
};

const onRelationClear = () => {
  invoiceData.value.fMvasete = null;
  selectedRelation.value = null;
};
// Watch doctors combo items and set default doctor if needed
watch(() => doctorsComboStore.itemsList, async (newList) => {
  if (newList && newList.length && !(invoiceData.value && invoiceData.value.fMdocid)) {
    await setDefaultDoctorFromStore();
  }
}, { deep: true });


// --- doctor ---
const onDoctorSelected = async (doctor) => {
  if (doctor) {
    invoiceData.value.fMdocid = doctor.fDauto;
    selectedDoctor.value = {
      firstName: doctor.fDname || doctor.fDfirst || '',
      lastName: doctor.fDlast || '',
      fDauto: doctor.fDauto,
      fDtakhasos: doctor.fDtakhasos,
      fDnezamno: doctor.fDnezamno
    };
    // call GetMaxFactorNumber for selected doctor
    try {
      const maxFactor = await GetMaxFactorNumber(doctor.fDauto);
      if (maxFactor) {
        invoiceData.value.fMfactno = maxFactor.toString();
      }
    } catch (e) {
      console.error('Error fetching max factor number for doctor:', e);
    }
  } else {
    invoiceData.value.fMdocid = null;
    selectedDoctor.value = null;
  }
};

const onDoctorSearch = (query) => {
};

const onDoctorClear = () => {
  invoiceData.value.fMdocid = null;
  selectedDoctor.value = null;
};

const formattedDate = computed(() => {
  return invoiceData.value.date || moment().format('jYYYY/jMM/jDD')
})

const totalAmount = computed(() => {
  return invoiceData.value.items.reduce((sum, item) => {
    return sum + (item.fMdmprice || 0)
  }, 0)
})

const totalVatAmount = computed(() => {
  return invoiceData.value.items.reduce((sum, item) => {
    return sum + (item.fMdmalyat || 0)
  }, 0)
})

const totalWithoutVat = computed(() => {
  return invoiceData.value.items.reduce((sum, item) => {
    return sum + (item.fMdkprice || 0)
  }, 0)
})


const canSaveInvoice = computed(() => {
  return invoiceData.value.fMfactno &&
    invoiceData.value.fMprsnid &&
    selectedDoctor && selectedDoctor.value &&
    invoiceData.value.items.some(item => item.description && item.fMpmblg > 0)
})
// --- doctor ---
const onServiceSelected = (index, service) => {
  // service is the full selected service object, index is the row in invoiceData.items
  if (!Number.isInteger(index)) return;
  const item = invoiceData.value.items[index];
  if (!item) return;

  if (service) {
    // set the ID (v-model) and other metadata on the row (description, price)
    item.fMbsauto = service.fSauto;
    item.description = service.fSname || item.description;
    // if the service includes a default price field (e.g., fSprice), set it
    if (service.fSfee || service.fSprice) {
      item.fMpmblg = service.fSfee || service.fSprice;
    }
    // recalc totals
    calculateItemTotal(index);
  } else {
    // if service cleared, reset the row as needed
    item.fMbsauto = null;
    item.description = '';
    item.fMpmblg = 0;
    item.fMtedad = 1;
    item.fMdtakhfif = 0;
    item.vatRate = 10;
    calculateItemTotal(index);
  }
};

const onServiceSearch = (query) => {
};

const onServiceClear = () => {
};

// Methods
// Helper: select default doctor from doctorsComboStore if available
const setDefaultDoctorFromStore = async () => {
  try {
    const items = doctorsComboStore.itemsList || [];
    if (!items || items.length === 0) return;
    if (invoiceData.value && invoiceData.value.fMdocid) return;

    const defaultDoctor = items.find(d => d.isDefault == true);
    if (defaultDoctor) {
      await onDoctorSelected(defaultDoctor);
    }
  } catch (e) {
    console.error('Error while selecting default doctor from combo store:', e);
  }
};

async function loadComboData() {
  try {
    await Promise.all([
      serviceComboStore.loadInitialData(),
      patientsComboStore.loadInitialData(),
      doctorsComboStore.loadInitialData(),
    ]);
    // Combo data loaded successfully
  } catch (error) {
    console.warn('Combo data loading failed, but form is still functional:', error);
  }
  // run default selection after loading
  await setDefaultDoctorFromStore();
}
const previousInvoice = () => {
  if (currentInvoiceIndex.value > 0) {
    currentInvoiceIndex.value--
    // اینجا می‌توانید فاکتور قبلی را بارگیری کنید
    // بارگیری فاکتور قبلی
  }
}

const nextInvoice = () => {
  if (currentInvoiceIndex.value < totalInvoices.value - 1) {
    currentInvoiceIndex.value++
    // اینجا می‌توانید فاکتور بعدی را بارگیری کنید
    // بارگیری فاکتور بعدی
  }
}
// Watch for changes to doctor id on the invoice and call GetMaxFactorNumber
watch(() => invoiceData.value.fMdocid, async (newId, oldId) => {
  try {
    if (!newId) {
      lastFactorDoctorId.value = null;
      // optionally reset invoice number to a new default
      return;
    }
    if (newId === lastFactorDoctorId.value) return;
    const max = await factorsStore.GetMaxFactorNumber(newId);
    if (max) {
      const sf = max.toString();
      invoiceData.value.fMfactno = sf;
      lastFactorDoctorId.value = newId;
    }
    // If we have an existing reception number (either fMmyno or fMfactno), load the invoice from service
    const receptionNumber = invoiceData.value.fMmyno || invoiceData.value.fMfactno;
    if (receptionNumber) {
      await loadInvoiceFromService();
    }
  } catch (e) {
    console.error('Error in invoice doctor id watcher calling GetMaxFactorNumber:', e);
  }
}, { immediate: false });

const onReceptionChange = () => {
  // Use the updated field name fMmyno which maps to the reception number
  // Prefer fMmyno if set (reception number), otherwise fallback to invoice number fMfactno
  const receptionNumber = invoiceData.value.fMfactno;
  const selectedReception = receptionsList.value.find(r => r.id === receptionNumber)
  if (selectedReception) {
    // reception selected; if the reception contains patient and doctor information, set them
    if (selectedReception.patientId) {
      const patient = patientsStore.patientsList.find(p => p.id === selectedReception.patientId)
      if (patient) {
        selectedPatient.value = patient
      }
    }
    if (selectedReception.doctorId) {
      const doc = doctorsStore.doctorsList.find(d => d.fDauto === selectedReception.doctorId || d.id === selectedReception.doctorId)
      if (doc) {
        // set doctor fields on the invoice and update selectedDoctor
        invoiceData.value.fMdocid = doc.fDauto || doc.id
        selectedDoctor.value = {
          firstName: doc.fDname || doc.firstName || '',
          lastName: doc.fDlast || doc.lastName || '',
          fDauto: doc.fDauto || doc.id,
          fDtakhasos: doc.fDtakhasos,
          fDnezamno: doc.fDnezamno
        }
      }
    }
  }

  // If we have both a doctor id and a reception number, try to load the factor from the server
  if (invoiceData.value.fMdocid && receptionNumber) {
    loadInvoiceFromService();
  }
}

// Load the invoice (factor) from the server given the selected doctor and reception number
const loadInvoiceFromService = async () => {
  try {
    const doctorId = invoiceData.value.fMdocid;
    const receptionNumber = invoiceData.value.fMfactno;
    // If there's no doc or no number to search by, nothing to do
    if (!doctorId || !receptionNumber) return;

    // remember if the form had any data before we tried to load a server factor
    const hadDataBefore = !!(invoiceData.value.fMprsnid || invoiceData.value.fMdocid || invoiceData.value.fMdesc ||
      (invoiceData.value.items && invoiceData.value.items.some(item => item.description || item.fMbsauto || (item.fMpmblg || 0) > 0)));

    // First attempt: try using the reception number (fMmyno) or fMfactno whatever is present
    await fetchFactor(doctorId, receptionNumber);
    let serverData = FactorEntity.value;

    const isEmpty = (data) => {
      return (!data || Object.keys(data).length === 0 || (data.result && Array.isArray(data.result) && data.result.length === 0));
    };

    // If server returned no data and we had both reception and invoice numbers available, try the other number
    if (isEmpty(serverData) && invoiceData.value.fMfactno && receptionNumber !== invoiceData.value.fMfactno) {
      await fetchFactor(doctorId, invoiceData.value.fMfactno);
      serverData = FactorEntity.value;
    }

    // Still nothing? call GetMaxFactorNumber to populate fMfactno and, if we had data before, reset the form
    if (isEmpty(serverData)) {
      if (hadDataBefore) {
        // If the form had been populated before and we got no server data, reset to avoid mixing data
        console.info('No server data returned; resetting form because there was existing data');
        resetForm();
        const max = await GetMaxFactorNumber(doctorId);
        if (max) {
          invoiceData.value.fMfactno = max.toString();
          lastFactorDoctorId.value = doctorId;
        }
        await setDefaultDoctorFromStore();
      }
      return;
    }
    // If server data contains a 'result' array, choose the first element
    if (serverData.result && Array.isArray(serverData.result) && serverData.result.length > 0) {
      serverData = serverData.result[0];
    }
    if (!serverData) return;
    invoiceData.value = {
      ...invoiceData.value,
      ...serverData,
      // normalize common field names in case API returns different property names
      fMmyno: serverData.fMmyno || serverData.receptionNumber || invoiceData.value.fMmyno,
      fMdate: serverData.fMdate || serverData.date || invoiceData.value.fMdate,
      date: serverData.date || serverData.fMdate || invoiceData.value.date,
      fMfactno: serverData.fMfactno || serverData.invoiceNumber || invoiceData.value.fMfactno
    };

    // If returned includes patient ID, update selectedPatient (try multiple id fields)
    const patientId = serverData.fMprsnid || serverData.fTauto || serverData.patientId || serverData.patient?.id;
    if (patientId) {
      const patient = patientsStore.patientsList.find(p => p.fTauto === patientId || p.id === patientId);
      if (patient) {
        selectedPatient.value = patient;
      }
    }

    // If returned includes doctor id, update the selected doctor
    const docId = serverData.fMdocid || serverData.fDauto || serverData.doctorId || serverData.doctor?.id;
    if (docId) {
      const doc = doctorsStore.doctorsList.find(d => d.fDauto === docId || d.id === docId);
      if (doc) {
        selectedDoctor.value = {
          firstName: doc.fDname || doc.firstName || '',
          lastName: doc.fDlast || doc.lastName || '',
          fDauto: doc.fDauto || doc.id,
          fDtakhasos: doc.fDtakhasos,
          fDnezamno: doc.fDnezamno
        };
        invoiceData.value.fMdocid = doc.fDauto || doc.id;
      }
    }
    console.info('Invoice loaded from service', serverData);
  } catch (e) {
    console.error('Error loading invoice from service:', e);
  }
}

const addItem = () => {
  invoiceData.value.items.push({
    description: '',
    fMbsauto: null,
    fMtedad: 1,
    fMpmblg: 0,
    fMdtakhfif: 0,
    vatRate: 10,
    total: 0,
    vatAmount: 0,
    fMdmprice: 0,
    fMdkprice: 0,
    fMdmalyat: 0,
  })
}

const removeItem = async (index) => {
  let recordId = invoiceData.value.items[index].fMrdf;
  if (recordId) {
    const confirmed = await confirm({
      title: 'حذف اقلام فاکتور',
      message: 'آیا از حذف این رکورد اطمینان دارید؟',
      confirmText: 'بله، حذف شود',
      cancelText: 'انصراف'
    })
    if (!confirmed) return;
    try {
      await deleteFactorItem(recordId);
      // Remove item from local array (if available)
      invoiceData.value.items.splice(index, 1)
      toast.success('نوبت با موفقیت حذف شد')
    } catch (error) {
      console.error("Error deleting reception:", error);
      toast.error("خطا در حذف");
    }
  } else {
    invoiceData.value.items.splice(index, 1)
  }
}

// حذف استپر تعداد: هندلرها دیگر استفاده نمی‌شوند

const calculateItemTotal = (index) => {
  const item = invoiceData.value.items[index]
  const baseTotal = (item.fMtedad || 0) * (item.fMpmblg || 0)
  const discount = Math.max(0, item.fMdtakhfif || 0)
  const subtotalAfterDiscount = Math.max(0, baseTotal - discount)
  item.vatRate = 10;
  const vatRate = (item.vatRate || 0) / 100

  item.vatAmount = baseTotal * vatRate
  item.fMdkprice = subtotalAfterDiscount
  item.fMdmalyat = (item.fMdkprice * vatRate);
  item.fMdmprice = subtotalAfterDiscount + (subtotalAfterDiscount * vatRate)
}

const formatNumber = (number) => {
  return new Intl.NumberFormat('fa-IR').format(number)
}

const saveInvoice = async () => {
  if (!canSaveInvoice.value) {
    alert('لطفاً تمام فیلدهای اجباری را پر کنید')
    return
  }
  if (invoiceData.value.fMfactid === 0) {
    await addFactor({ ...invoiceData.value });
  } else {
    await updateFactor({ ...invoiceData.value });
  }
  await loadInvoiceFromService();
}

const onDisabledSaveClick = (e) => {
  // Only show message when the save button is disabled
  if (canSaveInvoice.value) return;
  e?.preventDefault?.();
  e?.stopPropagation?.();
  openSaveHintModal.value = true
}

const printInvoice = () => {
  // نمایش قالب چاپی و چاپ
  const printContent = generatePrintContent()
  const printWindow = window.open('', '_blank')
  printWindow.document.write(printContent)
  printWindow.document.close()
  printWindow.print()
}

// Secondary actions
const { confirm } = useConfirm()
const newInvoice = async () => {
  resetForm();
  await setDefaultDoctorFromStore();
  const doctorId = invoiceData.value.fMdocid;
  const max = await GetMaxFactorNumber(doctorId);
  if (max) {
    invoiceData.value.fMfactno = max.toString();
    lastFactorDoctorId.value = doctorId;
  }
}

const deleteInvoice = async () => {
  if (!invoiceData.value.fMfactid) {
    toast.error('قبض نامعتبر است')
    return
  }
  const confirmed = await confirm({
    title: 'حذف قبض',
    message: 'آیا از حذف این قبض اطمینان دارید؟',
    confirmText: 'بله، حذف شود',
    cancelText: 'انصراف'
  })
  if (!confirmed) return
  await deleteFactor(invoiceData.value.fMfactid)
  await newInvoice()
}

const voidInvoice = async () => {
  if (invoiceData.value.fMbatel === 1) {
    toast.error('قبض در وضعیت ابطال می باشد')
    return
  }
  if (!invoiceData.value.fMfactid) {
    toast.error('قبض نامعتبر است')
    return
  }
  const confirmed = await confirm('آیا از ابطال این قبض مطمئن هستید؟')
  if (!confirmed) return
  await CancelInvoice(invoiceData.value.fMfactid)

}

const settleInvoice = () => {
  if (!invoiceData.value.fMfactno) {
    alert('شماره قبض نامعتبر است')
    return
  }
  console.log('[clinic-invoice] settleInvoice called. fMfactno=', invoiceData.value.fMfactno)
  console.log('[clinic-invoice] showSettleModal before:', showSettleModal.value)
  // Open settlement modal for adding/viewing settlements
  openSettleModal()
}

function openSettleModal() {
  console.log('[clinic-invoice] openSettleModal called')
  toast.info('در حال باز کردن مودال تسویه')
  if (invoiceData.value.settlements && Array.isArray(invoiceData.value.settlements)) {
    settleRecords.value = invoiceData.value.settlements.slice()
  } else {
    settleRecords.value = []
  }
  showSettleModal.value = true
  console.log('[clinic-invoice] showSettleModal after:', showSettleModal.value)
}

function closeSettleModal() {
  showSettleModal.value = false
  editingSettleIndex.value = -1
}

function newSettlement() {
  settleForm.date = moment().format('jYYYY/jMM/jDD')
  settleForm.amount = 0
  settleForm.type = ''
  settleForm.docNumber = ''
  settleForm.reason = ''
  settleForm.notes = ''
  editingSettleIndex.value = -1
}

function saveSettlement() {
  if (!settleForm.date || !settleForm.amount || Number(settleForm.amount) <= 0) {
    alert('لطفا تاریخ و مبلغ دریافت را وارد کنید')
    return
  }
  if (settleForm.notes && settleForm.notes.trim().length > 250) {
    alert('توضیحات نباید بیش از 250 کاراکتر باشد')
    return
  }
  const record = {
    id: editingSettleIndex.value >= 0 ? settleRecords.value[editingSettleIndex.value].id : Date.now(),
    date: settleForm.date,
    amount: Number(settleForm.amount),
    type: settleForm.type,
    docNumber: settleForm.docNumber,
    reason: settleForm.reason,
    notes: settleForm.notes
  }
  if (editingSettleIndex.value >= 0) {
    settleRecords.value.splice(editingSettleIndex.value, 1, record)
  } else {
    settleRecords.value.push(record)
  }
  // persist to invoiceData
  invoiceData.value.settlements = settleRecords.value.slice()
  newSettlement()
  toast.success('تسویه با موفقیت ثبت شد')
}

function editSettlement(index) {
  const r = settleRecords.value[index]
  if (!r) return
  settleForm.date = r.date
  settleForm.amount = r.amount
  settleForm.type = r.type
  settleForm.docNumber = r.docNumber
  settleForm.reason = r.reason
  settleForm.notes = r.notes
  editingSettleIndex.value = index
}

async function deleteSettlement(index) {
  const confirmed = await confirm('آیا از حذف این رکورد اطمینان دارید؟')
  if (!confirmed) return
  settleRecords.value.splice(index, 1)
  invoiceData.value.settlements = settleRecords.value.slice()
  toast.success('رکورد تسویه حذف شد')
}

function printSettlement(index) {
  const r = settleRecords.value[index]
  if (!r) return
  const html = `<html dir="rtl"><body><h3>رسید پرداخت</h3><p>تاریخ: ${r.date}</p><p>مبلغ: ${formatNumber(r.amount)} ریال</p></body></html>`
  const w = window.open('', '_blank')
  if (w) {
    w.document.write(html)
    w.document.close()
    w.print()
  }
}

const generatePrintContent = () => {
  const doctor = selectedDoctor.value
  const doctorName = doctor ? `${doctor.firstName} ${doctor.lastName}` : 'تعیین نشده'

  return `
        <!DOCTYPE html>
        <html dir="rtl" lang="fa">
        <head>
          <meta charset="UTF-8">
          <title>قبض رسید دریافت وجه</title>
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            
            body {
              font-family: 'Tahoma', 'Arial', sans-serif;
              direction: rtl;
              text-align: right;
              background: white;
              padding: 20px;
            }
            
            .receipt-container {
              width: 400px;
              margin: 0 auto;
              border: 3px solid #000;
              background: white;
            }
            
            .receipt-header {
              background: #f0f0f0;
              padding: 15px;
              text-align: center;
              border-bottom: 2px solid #000;
            }
            
            .receipt-title {
              font-size: 18px;
              font-weight: bold;
              margin-bottom: 10px;
            }
            
            .receipt-body {
              padding: 15px;
            }
            
            .info-row {
              display: flex;
              justify-content: space-between;
              margin-bottom: 10px;
              font-size: 14px;
            }
            
            .info-row.center {
              justify-content: center;
              text-align: center;
            }
            
            .doctor-name {
              text-align: center;
              margin: 15px 0;
              font-size: 16px;
              font-weight: bold;
            }
            
            .amount-section {
              margin: 20px 0;
            }
            
            .amount-row {
              display: flex;
              justify-content: space-between;
              margin-bottom: 8px;
              font-size: 14px;
            }
            
            .amount-words {
              text-align: center;
              margin: 10px 0;
              font-size: 13px;
            }
            
            .from-to-section {
              margin: 20px 0;
            }
            
            .service-section {
              border: 2px solid #000;
              margin: 15px 0;
            }
            
            .service-header {
              display: flex;
              border-bottom: 2px solid #000;
            }
            
            .service-col {
              padding: 8px;
              text-align: center;
              font-weight: bold;
              border-left: 2px solid #000;
            }
            
            .service-col:last-child {
              border-left: none;
            }
            
            .service-col.description {
              flex: 2;
            }
            
            .service-col.code {
              flex: 1;
            }
            
            .service-row {
              display: flex;
              border-bottom: 1px solid #000;
            }
            
            .service-row:last-child {
              border-bottom: none;
            }
            
            .service-data {
              padding: 8px;
              text-align: center;
              border-left: 2px solid #000;
            }
            
            .service-data:last-child {
              border-left: none;
            }
            
            .service-data.description {
              flex: 2;
            }
            
            .service-data.code {
              flex: 1;
            }
            
            .totals-section {
              margin: 15px 0;
            }
            
            .total-row {
              display: flex;
              justify-content: space-between;
              margin-bottom: 5px;
              font-size: 14px;
            }
            
            .notes-section {
              border: 2px solid #000;
              min-height: 60px;
              padding: 10px;
              margin: 15px 0;
            }
            
            .notes-title {
              font-weight: bold;
              margin-bottom: 5px;
            }
            
            .notes-content {
              white-space: pre-wrap;
              word-wrap: break-word;
              line-height: 1.6;
            }
            
            .footer-section {
              border-top: 2px solid #000;
              padding: 10px;
              margin-top: 15px;
            }
            
            .footer-row {
              display: flex;
              justify-content: space-between;
              margin-bottom: 5px;
              font-size: 12px;
            }
            
            .clinic-info {
              text-align: center;
              font-size: 11px;
              margin-top: 10px;
              border-top: 1px solid #000;
              padding-top: 5px;
            }
            
            @media print {
              body {
                padding: 0;
              }
              
              .receipt-container {
                width: 100%;
                max-width: 400px;
              }
            }
          </style>
        </head>
        <body>
          <div class="receipt-container">
            <div class="receipt-header">
              <div class="receipt-title">قبض رسید دریافت وجه</div>
            </div>
            
            <div class="receipt-body">
              <div class="doctor-name">نام پزشک : ${doctorName}</div>
              
              <div class="amount-section">
                <div class="amount-row">
                  <span>مبلغ : ${formatNumber(totalAmount.value)}</span>
                  <span>تاریخ : ${invoiceData.value.date}</span>
                </div>
                <div class="amount-words">به حروف : ${convertToWords(totalAmount.value)} ریال</div>
              </div>
              
              <div class="from-to-section">
                <div class="info-row">
                  <span>از : علی محمدی</span>
                </div>
                <div class="info-row">
                  <span>شماره قبض : ${invoiceData.value.fMfactno}</span>
                  <span>دریافت گردید.</span>
                </div>
              </div>
              
              <div class="service-section">
                <div class="service-header">
                  <div class="service-col description">شرح خدمات</div>
                  <div class="service-col code">کد خدمات</div>
                </div>
                ${invoiceData.value.items.map(item => `
                  <div class="service-row">
                    <div class="service-data description">${item.description || 'تزریق زاویه فک'}</div>
                    <div class="service-data code">001001</div>
                  </div>
                `).join('')}
              </div>
              
              <div class="totals-section">
                <div class="total-row">
                  <span>سهم بیمار : ${formatNumber(totalAmount.value)}</span>
                  <span>ریال</span>
                </div>
                <div class="total-row">
                  <span>سهم سازمان :</span>
                  <span>ریال</span>
                </div>
                <div class="total-row">
                  <span>باقیماند :</span>
                  <span>ریال</span>
                </div>
              </div>
              
              <div class="notes-section">
                <div class="notes-title">توضیحات :</div>
                <div class="notes-content">${invoiceData.value.notes || ''}</div>
              </div>
              
              <div class="footer-section">
                <div class="footer-row">
                  <span>کاربر ثبت کننده : مدیر سیستم</span>
                </div>
                <div class="footer-row">
                  <span>ساعت ثبت : ${moment().format('HH:mm:ss')}</span>
                  <span>تاریخ ثبت : ${moment().format('jYYYY/jMM/jDD')}</span>
                </div>
              </div>
              
              <div class="clinic-info">
                سامانه مطب سینا پردازش www.sinapardazesh.ir
              </div>
            </div>
          </div>
        </body>
        </html>
      `
}

const convertToWords = (number) => {
  // تبدیل عدد به حروف فارسی - پیاده‌سازی ساده
  if (number === 0) return 'صفر'

  const ones = ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه']
  const tens = ['', '', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود']
  const hundreds = ['', 'یکصد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد']

  if (number < 10) return ones[number]
  if (number < 100) {
    const ten = Math.floor(number / 10)
    const one = number % 10
    if (number < 20) {
      const teens = ['ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده', 'هفده', 'هجده', 'نوزده']
      return teens[number - 10]
    }
    return tens[ten] + (one ? ' و ' + ones[one] : '')
  }
  if (number < 1000) {
    const hundred = Math.floor(number / 100)
    const remainder = number % 100
    return hundreds[hundred] + (remainder ? ' و ' + convertToWords(remainder) : '')
  }

  // برای اعداد بزرگتر، پیاده‌سازی ساده‌تر
  if (number >= 1000000) {
    return Math.floor(number / 1000000) + ' میلیون' + (number % 1000000 ? ' و ' + convertToWords(number % 1000000) : '')
  }
  if (number >= 1000) {
    return Math.floor(number / 1000) + ' هزار' + (number % 1000 ? ' و ' + convertToWords(number % 1000) : '')
  }

  return number.toString()
}

const resetForm = () => {
  invoiceData.value = {
    fMfactid: 0,
    fMfactno: 0,
    fMbatel: 0,
    fMdate: moment().format('jYYYY/jMM/jDD'),
    fMmyno: '',
    fMdocid: null,
    fMprsnid: null,
    fBimeh: 1,
    fMvasete: null,
    fMdesc: '',
    items: [
      {
        description: '',
        fMbsauto: null,
        fMtedad: 1,
        fMpmblg: 0,
        fMdtakhfif: 0,
        vatRate: 10,
        total: 0,
        vatAmount: 0,
        fMdmprice: 0,
        fMdkprice: 0,
        fMdmalyat: 0,
      }
    ]
  }

  // پاک کردن فیلدهای جستجوی بیمار
  patientSearchQuery.value = ''
  selectedPatient.value = null
  showPatientDropdown.value = false

  // پاک کردن فیلدهای جستجوی واسطه
  intermediarySearchQuery.value = ''
  selectedIntermediary.value = null
  showIntermediaryDropdown.value = false

}

// Lifecycle
onMounted(async () => {
  await Promise.all([
    doctorsStore.fetchDoctors(),
    patientsStore.fetchPatients()
  ])
  // Load combo select data (services, doctors, patients) used by GenericSelect components
  await loadComboData();
  // تنظیم تاریخ امروز
  invoiceData.value.date = moment().format('jYYYY/jMM/jDD')

})

// Info modal now handled by PageHeader; openInfoModal removed

</script>

<style scoped>
/* Wrapper to capture click when BaseButton is disabled (disabled buttons don't emit click) */
.save-invoice-btn-wrap {
  display: inline-flex;
  position: relative;
}

.save-invoice-btn-overlay {
  position: absolute;
  inset: 0;
  cursor: help;
  /* invisible but clickable */
  background: transparent;
}
</style>

<style scoped>
:root {
  --text-color-secondary: #6b7280;
  --text-color-secondary-rgb: 107, 114, 128;
}

.invoice-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
}

/* Give the page header some space from the content below */
.invoice-container>.header {
  margin-bottom: 20px;
}

.invoice-header {
  background: var(--background-color-secondary);
  border: 1px solid var(--text-color-secondary);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(var(--text-color-secondary-rgb), 0.1);
}

.invoice-second-row {
  background: var(--background-color-secondary);
  border: 1px solid var(--text-color-secondary);
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
  box-shadow: 0 2px 4px rgba(var(--text-color-secondary-rgb), 0.1);
}

.second-row-content {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1.5fr;
  gap: 20px;
  align-items: end;
}

@media (max-width: 1200px) {
  .second-row-content {
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }
}

@media (max-width: 768px) {
  .second-row-content {
    grid-template-columns: 1fr;
    gap: 15px;
  }
}

.header-row {
  /* Use CSS grid for predictable responsive behavior and stacking */
  display: grid;
  /* Match second-row distribution so both rows behave consistently */
  grid-template-columns: 0.5fr 1fr 1fr 1.5fr;
  gap: 16px;
  align-items: end; /* align children to bottom */
  grid-auto-flow: row; /* ensure grid wraps to new rows predictably */
  grid-auto-columns: minmax(0, 1fr);
}
.header-row .form-group { width: 100%; min-width: 0; max-width: 100%; }
.header-row .navigation-buttons { justify-self: center; }

/* Modal overlay styles (copy of generic modal used across clinic pages) */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background-color: rgba(var(--text-color-secondary-rgb), 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  -webkit-backdrop-filter: saturate(180%) blur(5px) !important;
  backdrop-filter: saturate(180%) blur(5px) !important;
}

.modal-content {
  background-color: var(--background-color);
  padding: 0 20px 20px 20px;
  border-radius: 30px;
  width: auto;
  max-height: 90vh;
  max-width: 90vw;
  overflow-y: auto;
  position: relative;
  direction: rtl;
  --action-col-width: 120px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px;
}

.center-modal-overlay { align-items: center !important; padding: 12px !important; }

/* Settlement modal specific layout */
.modal-sub-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: sticky;
  top: 0;
  background-color: var(--background-color);
  gap: 8px;
  z-index: 99;
  padding-top: 12px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.sub-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: var(--text-color-secondary);
  width: 100% !important;
}

.form-actions {
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
}

.settle-header-text p { font-size: 14px; color: var(--text-color-primary);margin-bottom: 20px; }

.settle-form-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  grid-auto-rows: minmax(44px, auto);
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label { font-size: 13px; color: var(--text-color-secondary); }

.form-input {
  padding: 8px 10px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 6px;
  font-size: 14px;
  background: var(--background-color);
  color: var(--text-color-primary);
  width: 100%;
  resize: vertical;
  min-height: 40px;
}

.p-date .form-date-picker { width: 100%; }

.action-btn { display: inline-flex; align-items: center; justify-content: center; padding: 6px; width: 34px; height: 34px; border-radius: 6px; border: none; background: transparent; cursor: pointer; }
.action-btn img { width: 18px; height: 18px; }
.action-btn.edit { color: #1476f3; }
.action-btn.delete { color: #ff0f0f; }

.patients-table { width: 100%; text-align: right; font-size: 14px; color: var(--text-color-primary); border-collapse: separate; border-spacing: 0; }
.patients-table th, .patients-table td { padding: 10px 12px; border-bottom: 1px solid #e5e7eb; white-space: nowrap; }
.patients-table td { border-left: 1px solid #e5e7eb; }
.patients-table td:last-child { border-left: none; }
.patients-table thead { background-color: var(--hover-background-color); }
.patients-table th { position: sticky; top: 0; z-index: 2; font-weight: bold; border-left: 1px solid #e5e7eb; background-color: var(--hover-background-color); }
.patients-table th:last-child, .patients-table td:last-child { position: sticky; right: 0; z-index: 1; box-shadow: -10px 0 10px -5px rgba(var(--text-color-secondary-rgb), 0.25); }

.divider-line { border: none; border-top: 1px solid rgba(var(--text-color-secondary-rgb), 0.1); margin: 8px 0; }

.new-button { padding: 8px 16px; border-radius: 8px; background: var(--background-color-button2); color: var(--text-color-primary); border: none; cursor: pointer; }
/* submit-button replaced by BaseButton (variant="primary") */


@media (max-width: 1024px) {
  .settle-form-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 768px) {
  .settle-form-grid { grid-template-columns: 1fr; }
  .patients-table th, .patients-table td { padding: 8px 10px; }
}



/* Column sizing inside header row */
.header-row .navigation-buttons {
  /* place in flow, allow grid to position it */
  justify-self: center;
}

.header-row .date-group {
  min-width: 0; /* allow element to shrink */
  width: auto;
}

.header-row .invoice-group {
  min-width: 0;
  width: auto;
}

.header-row .reception-group {
  min-width: 0;
  width: auto;
}

.header-row .doctor-group {
  min-width: 0;
  width: auto;
}

/* Ensure the header container can scroll horizontally if needed */
.invoice-header {
  overflow-x: hidden; /* prevent horizontal scroll; grid will wrap inside */
  overflow-y: hidden;
  /* hide vertical scroll that appeared */
}

.navigation-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  align-self: flex-end;
  /* push nav buttons down so arrows align with bottom of inputs */
}

.nav-btn {
  width: 40px;
  height: 40px;
  border: 1px solid var(--text-color-secondary);
  background: var(--background-color-secondary);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  color: var(--text-color-primary);
  align-self: flex-end;
  /* ensure the arrow buttons align to bottom of the header row */
  margin-bottom: 4px;
  /* slight nudge downwards visually */
}

.nav-btn:hover:not(:disabled) {
  background: var(--hover-background-color);
  color: var(--text-color-primary);
}

.nav-btn:disabled {
  border-color: var(--text-color-secondary);
  color: var(--text-color-secondary);
  cursor: not-allowed;
  background: var(--background-color-secondary);
}

.invoice-counter {
  font-size: 12px;
  color: #666;
  white-space: nowrap;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-weight: 600;
  color: var(--text-color-primary);
  font-size: 14px;
}

.form-group label .required {
  color: #dc3545;
  margin-right: 3px;
  font-weight: bold;
}

.form-select,
.form-input {
  padding: 8px 10px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 6px;
  font-size: 14px;
  text-align: right;
  direction: rtl;
  background: var(--background-color);
  color: var(--text-color-primary);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

/* Make the invoice-number input compact (34px height) per UX request */
#invoice-number.form-input {
  min-height: 34px; /* override default min-height */
  height: 34px;
  padding: 6px 10px; /* reduce vertical padding to fit 34px height */
  box-sizing: border-box;
}

/* Make the reception-number input and date input match invoice-number height (34px) */
#reception-number.form-input {
  min-height: 34px;
  height: 34px;
  padding: 6px 10px;
  box-sizing: border-box;
}

/* Target the inner input of the DatePicker (input-class='form-input') */
.p-date :deep(.form-input) {
  min-height: 34px;
  height: 34px;
  padding: 6px 10px;
  box-sizing: border-box;
}

.form-select {
  cursor: pointer;
}

.form-select:focus,
.form-input:focus {
  outline: none;
  border-color: var(--background-color-button);
  box-shadow: 0 0 0 0.2rem rgba(var(--background-color-button-rgb), 0.25);
}



.patient-search-group {
  position: relative;
}

.patient-search-container {
  position: relative;
}

.patient-search-input {
  width: 100%;
}

.patient-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--background-color);
  border: 1px solid var(--text-color-secondary);
  border-top: none;
  border-radius: 0 0 6px 6px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(var(--text-color-secondary-rgb), 0.1);
}

.patient-item {
  padding: 12px;
  cursor: pointer;
  border-bottom: 1px solid var(--text-color-secondary);
  transition: background-color 0.2s;
}

.patient-item:hover {
  background-color: var(--background-color-secondary);
}

.patient-item:last-child {
  border-bottom: none;
}

.patient-name {
  font-weight: 600;
  margin-bottom: 4px;
  color: var(--text-color-primary);
}

.patient-details {
  display: flex;
  gap: 15px;
  font-size: 12px;
  color: var(--text-color-secondary);
  flex-wrap: wrap;
}

.patient-code,
.patient-mobile,
.patient-file {
  background: var(--background-color-secondary);
  padding: 2px 6px;
  border-radius: 3px;
}

/* Intermediary search styles (similar to patient search) */
.intermediary-search-group {
  position: relative;
}

.intermediary-search-container {
  position: relative;
}

.intermediary-search-input {
  width: 100%;
}

.intermediary-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: var(--background-color);
  border: 1px solid var(--text-color-secondary);
  border-top: none;
  border-radius: 0 0 6px 6px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 4px 6px rgba(var(--text-color-secondary-rgb), 0.1);
}

.intermediary-item {
  padding: 12px;
  cursor: pointer;
  border-bottom: 1px solid var(--text-color-secondary);
  transition: background-color 0.2s;
}

.intermediary-item:hover {
  background-color: var(--background-color-secondary);
}

.intermediary-item:last-child {
  border-bottom: none;
}

.intermediary-name {
  font-weight: 600;
  margin-bottom: 4px;
  color: var(--text-color-primary);
}

.intermediary-details {
  display: flex;
  gap: 15px;
  font-size: 12px;
  color: var(--text-color-secondary);
  flex-wrap: wrap;
}

.intermediary-code,
.intermediary-mobile,
.intermediary-file {
  background: var(--background-color-secondary);
  padding: 2px 6px;
  border-radius: 3px;
}

.invoice-content {
  background: var(--background-color);
  border: 1px solid var(--text-color-secondary);
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 4px rgba(var(--text-color-secondary-rgb), 0.1);
}

.invoice-form h3 {
  margin-bottom: 20px;
  color: var(--text-color-primary);
  padding-bottom: 10px;
}

.summary-info {
  background: var(--background-color-secondary);
  border: 1px solid var(--text-color-secondary);
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 25px;
}

.info-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.info-item {
  font-size: 14px;
}

.patient-file-info {
  color: var(--text-color-secondary);
  font-size: 12px;
  margin-right: 5px;
}

.invoice-items h4 {
  margin-bottom: 15px;
  color: var(--text-color-primary);
}

.items-table {
  /* Match BaseTable wrapper look while keeping the local container hook */
  border: 1px solid var(--text-color-secondary);
  border-radius: 6px;
}

.table-input {
  width: 100%;
  border: none;
  outline: none;
  padding: 4px;
  text-align: right;
  direction: rtl;
  background: transparent;
  color: var(--text-color-primary);
}

/* Compact (small) GenericSelect used inside the invoice items table to avoid row wrapping */
.items-table .generic-select.compact-select {
  max-width: 200px;
  /* smaller compact width to better fit table columns */
  min-width: 110px;
  /* a smaller minimum to help narrow screens */
  width: 100%;
}

/* Adjust internal v-select toggle to respect the compact size and look good */
:deep(.items-table .generic-select.compact-select) .vs__dropdown-toggle {
  padding: 4px 8px;
  min-width: 140px !important;
  max-width: 260px !important;
  box-sizing: border-box;
}

/* Make sure dropdown menu width doesn't cause overflow when appended to <body> */
:deep(.items-table .generic-select.compact-select) .vs__dropdown-menu {
  min-width: 140px !important;
  max-width: 420px !important;
}

/* For very narrow screens, let select grow but limit it so rows remain aligned */
@media (max-width: 640px) {
  .items-table .generic-select.compact-select {
    max-width: 100%;
    min-width: 120px;
  }
}

/* Prevent long service names from expanding the description column and breaking the layout */
.items-table .service-option .doctor-main strong,
.items-table .service-option .doctor-main {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Also ensure selected value in toggle shows ellipsis instead of expanding */
:deep(.items-table .generic-select.compact-select) .vs__selected,
:deep(.items-table .generic-select.compact-select) .vs__placeholder {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* استایل‌های استپر حذف شد */

.btn-remove {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-remove:hover {
  background: #c82333;
}

.table-actions {
  margin: 10px 0px 10px 0px;
}

.invoice-total {
  border-top: 1px solid var(--text-color-secondary);
  padding-top: 15px;
  margin-bottom: 25px;
}

.total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
}

.total-amount {
  color: var(--text-color-primary);
}

.final-total {
  border-top: 1px solid #757575;
  margin-top: 10px;
  padding-top: 10px;
  font-weight: 700;
  font-size: 16px;
}

.final-total .total-amount {
  color: var(--background-color-button);
  font-weight: 700;
}

.form-actions-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* راست: توضیحات | چپ: دکمه‌ها */
  gap: 20px;
  align-items: end;
}

.notes-group {
  flex: 1;
  min-width: 300px;
}

.actions-column {
  display: grid;
  grid-auto-rows: min-content;
  gap: 12px;
  align-self: end;
}

.actions-row {
  display: grid;
  grid-template-columns: repeat(3, minmax(120px, 1fr));
  gap: 12px;
  justify-items: stretch;
}

.actions-row .btn {
  width: 100%;
}

/* BaseButton in the actions grid should behave like .btn (full-width, centered label) */
.actions-row :deep(.base-button) {
  width: 100%;
  justify-content: center;
}

/* Mobile responsiveness for actions area */
@media (max-width: 768px) {
  .form-actions-row {
    grid-template-columns: 1fr;
    /* stack: notes on top, actions below */
    align-items: stretch;
  }

  .actions-column {
    align-self: stretch;
    display: grid;
    grid-template-columns: repeat(2, minmax(120px, 1fr));
    gap: 12px;
  }

  /* Flatten both rows into one grid so we get 3 rows x 2 columns */
  .actions-column .actions-row {
    display: contents;
  }
}

@media (max-width: 420px) {
  .actions-column {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
  }
}

/* Removed .form-textarea - use .form-input for textarea styling now */

.form-actions {
  display: flex;
  gap: 15px;
  justify-content: flex-end;
  flex-wrap: wrap;
}

.btn {
  padding: 10px 10px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}

.btn-primary {
  background-color: var(--background-color-button);
  color: var(--text-color-forthly);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--background-color-button-hover);
}

.btn-primary:disabled {
  background-color: var(--text-color-secondary);
  cursor: not-allowed;
}

.btn-secondary {
  background-color: var(--background-color-button2);
  color: var(--text-color-primary);
}

.btn-secondary:hover {
  background-color: var(--background-color-button-hover2);
  color: var(--text-color-primary);
}

.btn-info {
  background-color: var(--background-color-button);
  color: var(--text-color-forthly);
}

.btn-info:hover {
  background-color: var(--background-color-button-hover);
}

.btn .btn-icon {
  display: inline-flex;
  width: 18px;
  height: 18px;
  margin-left: 6px;
  vertical-align: middle;
}

.btn .btn-icon svg {
  width: 18px;
  height: 18px;
}

.btn-danger {
  background-color: #dc3545;
  color: #fff;
}

.btn-danger:hover {
  background-color: #c82333;
}

.btn-warning {
  background-color: #ffc107;
  color: #212529;
}

.btn-warning:hover {
  background-color: #e0a800;
}

.btn-success {
  background-color: var(--background-color-button);
  color: var(--text-color-forthly);
}

.btn-success:hover {
  background-color: var(--background-color-button-hover);
}

.p-date {
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: start;
  overflow: hidden;
  background-color: var(--background-color);
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.p-date :deep(.vpd-container) {
  border: 1px solid rgba(var(--text-color-secondary-rgb), 0.12);
  border-radius: 0.75rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  background-color: var(--background-color);
}

.p-date :deep(.vpd-input-group label) {
  background-color: var(--background-color-button) !important;
}

.p-date :deep(.vpd-input-group input) {
  border: none !important;
  line-height: 32px !important;
  background-color: var(--background-color) !important;
  color: var(--text-color-primary) !important;
  min-width: 95px;
}

.p-date :deep(.vpd-input-group input::placeholder) {
  color: var(--text-color-secondary) !important;
  opacity: 1;
}

.p-date :deep(.vpd-input-group input:focus) {
  border: 1px solid transparent !important;
}

.p-date :deep(.vpd-icon-btn),
.p-date :deep(button.vpd-icon-btn),
.p-date :deep(.vpd-actions button) {
  background-color: var(--background-color-button) !important;
  color: var(--background-color) !important;
  transition: background-color 0.3s ease !important;
}

.p-date :deep(.vpd-icon-btn svg),
.p-date :deep(button.vpd-icon-btn svg),
.p-date :deep(.vpd-actions button svg),
.p-date :deep(.vpd-icon-btn svg path),
.p-date :deep(button.vpd-icon-btn svg path),
.p-date :deep(.vpd-actions button svg path) {
  fill: var(--background-color) !important;
  color: var(--background-color) !important;
  stroke: var(--background-color) !important;
}

.p-date :deep(.vpd-icon-btn:hover),
.p-date :deep(button.vpd-icon-btn:hover),
.p-date :deep(.vpd-actions button:hover) {
  background-color: var(--background-color-button-hover) !important;
}

.p-date :deep(.vpd-addon-list) {
  background: var(--background-color) !important;
  border: 1px solid var(--text-color-secondary) !important;
}

.p-date :deep(.vpd-addon-list-item) {
  color: var(--text-color-primary) !important;
}

.p-date :deep(.vpd-addon-list-item:hover) {
  background: var(--background-color-secondary) !important;
}

.p-date :deep(.vpd-picker-container) {
  background: var(--background-color) !important;
  border: 1px solid var(--text-color-secondary) !important;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 5px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: start;
  width: 100%;
  background: var(--background-color-secondary);
  color: var(--text-color-primary);
}

.form-group input,
.form-group select {
  height: 34px;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--text-color-primary);
}

@media print {

  .navigation-buttons,
  .form-actions {
    display: none;
  }

  .invoice-container {
    padding: 0;
    box-shadow: none;
  }

  .invoice-header,
  .invoice-content {
    border: none;
    box-shadow: none;
  }
}
</style>

<style>
/* Global styles for teleported modal elements */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background-color: rgba(var(--text-color-secondary-rgb), 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 200000 !important;
  -webkit-backdrop-filter: saturate(180%) blur(6px) !important;
  backdrop-filter: saturate(180%) blur(6px) !important;
}
.modal-content {
  background-color: var(--background-color);
  padding: 0 20px 20px 20px;
  border-radius: 20px;
  width: auto;
  max-height: 88vh;
  max-width: 86vw;
  overflow-y: auto;
  position: relative;
  direction: rtl;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 12px;
}
.center-modal-overlay { align-items: center !important; padding: 12px !important; }
.modal-sub-header { position: sticky; top: 0; z-index: 99; }
/* submit-button replaced by BaseButton (variant="primary") */

.patients-table { width: 100%; }

/* Make the actions column in settlement modal sticky and visually distinct */
.modal-content .patients-table th.actions-header,
.modal-content .patients-table td.actions-cell {
  --action-col-width: 120px;
  position: sticky;
  right: 0; /* anchor to the right side of the wrapper */
  z-index: 3; /* above normal rows but below top inputs */
  background-color: var(--hover-background-color);
  /* subtle divider to separate from content when sticky */
  border-left: 1px solid rgba(var(--text-color-secondary-rgb), 0.12);
  box-shadow: -10px 0 10px -5px rgba(var(--text-color-secondary-rgb), 0.25);
  min-width: var(--action-col-width);
  width: var(--action-col-width);
}

.modal-content .patients-table th.actions-header {
  z-index: 5; /* header above rows but below top inputs */
}

.modal-content .patients-table td.actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 120px;
}

/* Ensure the settle-records table scrolls inside the modal container so sticky columns are relative to it */
.settle-records-table {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

.modal-content .settle-records-table .patients-table {
  width: max-content; /* allow horizontal overflow so wrapper controls scroll */
  min-width: 100%;
}

/* Reduce the wrapper left padding on small screens */
@media (max-width: 680px) {
  .modal-content .patients-table td.actions-cell { min-width: 90px; }
}

/* Make sure sticky actions column doesn't overflow the modal box visually */

/* Make header row responsive and stack items like the second row */
@media (max-width: 1200px) {
  .header-row {
    grid-template-columns: 1fr 1fr;
  }
}

/* (Removed the 1024px breakpoint to behave like second-row breakpoints at 1200 and 768) */

@media (max-width: 768px) {
  .header-row {
    grid-template-columns: 1fr;
  }
  .header-row .navigation-buttons { justify-self: start; grid-column: 1 / -1; }
  /* Allow inputs to shrink and stack without causing horizontal scroll */
  .header-row .date-group,
  .header-row .invoice-group,
  .header-row .reception-group,
  .header-row .doctor-group {
    min-width: 0; /* reset min widths so they can shrink to container */
    width: 100%;
  }
  /* Allow each header element to take the full width when stacked */
  .header-row .navigation-buttons,
  .header-row .date-group,
  .header-row .invoice-group,
  .header-row .reception-group,
  .header-row .doctor-group {
    grid-column: 1 / -1;
  }
  .header-row .date-group .form-date-picker,
  .header-row .date-group .form-input,
  .header-row .invoice-group .form-input {
    width: 100% !important;
  }
}
.modal-content .patients-table td.actions-cell {
  background-color: var(--background-color) !important; /* make background opaque */
}
</style>
